import React from 'react';
import PropTypes from 'prop-types';
import { ChildrenDefaultProp, ChildrenPropType } from '../../../prop-types/children';
import { DoorDialogStep } from '../styled/AdventCalendar';

export default class Step extends React.Component {
  render() {
    const {
      children,
      active,
    } = this.props;

    return (
      <DoorDialogStep active={active}>
        {children}
      </DoorDialogStep>
    );
  }
}

Step.propTypes = {
  ...ChildrenPropType,
  active: PropTypes.bool.isRequired,
};

Step.defaultProps = {
  ...ChildrenDefaultProp,
};
